export interface UTMParams {
  source?: string;
  campaign?: string;
  medium?: string;
}

export const captureUTMParams = (): UTMParams => {
  if (typeof window === 'undefined') {
    return {};
  }

  const urlParams = new URLSearchParams(window.location.search);
  
  return {
    source: urlParams.get('utm_source') || undefined,
    campaign: urlParams.get('utm_campaign') || undefined,
    medium: urlParams.get('utm_medium') || undefined,
  };
};

export const getStoredUTMParams = (): UTMParams => {
  if (typeof window === 'undefined') {
    return {};
  }

  try {
    const stored = localStorage.getItem('utm_params');
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};

export const storeUTMParams = (params: UTMParams): void => {
  if (typeof window === 'undefined') return;
  
  try {
    // Only store if we have at least one UTM parameter
    if (params.source || params.campaign || params.medium) {
      localStorage.setItem('utm_params', JSON.stringify(params));
    }
  } catch {
    // Silently fail if localStorage is not available
  }
};

// Initialize UTM tracking on page load
export const initUTMTracking = (): UTMParams => {
  const currentParams = captureUTMParams();
  storeUTMParams(currentParams);

  // Also persist to sessionStorage for inbound attribution
  // before user clicks through to a provider
  if (typeof window !== 'undefined') {
    try {
      const merged = { ...getStoredUTMParams(), ...currentParams };
      if (merged.source || merged.campaign || merged.medium) {
        sessionStorage.setItem('flexaura_inbound_utm', JSON.stringify(merged));
      }
    } catch {
      // Silently fail if sessionStorage unavailable
    }
  }

  return { ...getStoredUTMParams(), ...currentParams };
};

/** Read inbound UTMs from sessionStorage (set on first page load) */
export const getSessionUTMParams = (): UTMParams => {
  if (typeof window === 'undefined') return {};
  try {
    const stored = sessionStorage.getItem('flexaura_inbound_utm');
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};